
import { mapGetters } from 'vuex';
import SVGLogoWhite from '../../assets/svg/logo-white.svg';
import SVGEndoCert from '../../assets/svg/endoCert.svg';

export default {
  name: 'FooterComponent',
  components: { SVGLogoWhite, SVGEndoCert },
  data() {
    return {
      clicked: false
    };
  },
  computed: {
    ...mapGetters({
      isLoaderActive: 'ui/isLoaderActive',
      siteParts: 'settings/siteParts'
    })
  }
};
